/*!
 * SALT Ñ SOUL – Salty, der Größen-Chat
 * Liest Größentabellen aus den Produkt-Metafeldern (custom.size_chart), übergeben von snippets/salty-chat.liquid.
 */
(function () {
  'use strict';
  if (window.__saltyLoaded) return;
  window.__saltyLoaded = true;

  /* ---------------- Daten ---------------- */
  var D = { charts: {}, urls: {} };
  try { D = JSON.parse(document.getElementById('salty-data').textContent) || D; } catch (e) {}
  D.charts = D.charts || {}; D.urls = D.urls || {};

  var SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  var COLORS = ['clay', 'salt', 'basalt', 'sea grass', 'deep tide'];

  var PROD = {
    kompass: { label: 'SaltTee Kompass', handle: 'salttee-kompass', unisex: true, conv: true },
    smile:   { label: 'SaltTee Smile', handle: 'salttee-smile-oversized-shirt', unisex: true, conv: 'clay' },
    basic:   { label: 'SaltTee Basic', handle: 'salttee-basic-emblem', unisex: true, conv: false },
    hoodie:  { label: 'Ocean Hug Hoodie', handle: 'ocean-hug-oversized-heavyweight-hoodie', unisex: true, conv: true },
    fluffy:  { label: 'Ocean Hug Fluffy', handle: 'ocean-hug-fluffy-oversized-hoodie', unisex: false, conv: false }
  };
  var HANDLE2ID = {
    'salttee-kompass': 'kompass',
    'salttee-smile-oversized-shirt': 'smile',
    'salttee-basic-emblem': 'basic', 'salttee-basic-logo': 'basic',
    'ocean-hug-oversized-heavyweight-hoodie': 'hoodie', 'salt-hoodie-basic-emblem': 'hoodie', 'salt-hoodie-basic-logo': 'hoodie',
    'ocean-hug-fluffy-oversized-hoodie': 'fluffy',
    'dawn-patrol-beanie': 'beanie'
  };
  var pageId = D.product ? HANDLE2ID[D.product.handle] || null : null;

  /* Konfektionsgrößen (Herstellertabellen N9307 / N7200, Size Chart Unisex) */
  var CONV = {
    'DE/AT':    { w: { XS: [36, 38], S: [40, 42], M: [44, 46], L: [48, 50], XL: [50, 52], XXL: [54, 56], XXXL: [58, 60] },
                  m: { XS: [42, 44], S: [44, 46], M: [48, 50], L: [52, 54], XL: [56, 58], XXL: [60, 62], XXXL: [60, 62] } },
    'FR/ES/PT': { w: { XS: [38, 40], S: [42, 44], M: [46, 48], L: [50, 52], XL: [52, 54], XXL: [56, 58], XXXL: [60, 62] },
                  m: { XS: [42, 44], S: [44, 46], M: [48, 50], L: [52, 54], XL: [56, 58], XXL: [60, 62], XXXL: [60, 62] } },
    'IT':       { w: { XS: [40, 42], S: [44, 46], M: [48, 50], L: [52, 54], XL: [54, 56], XXL: [58, 60], XXXL: [62, 64] },
                  m: { XS: [30, 32], S: [34, 36], M: [38, 40], L: [42, 44], XL: [46, 48], XXL: [50, 52], XXXL: [54, 56] } },
    'UK':       { w: { XS: [10, 12], S: [14, 16], M: [18, 20], L: [22, 24], XL: [24, 26], XXL: [28, 30], XXXL: [32, 34] },
                  m: { XS: [30, 32], S: [34, 36], M: [38, 40], L: [42, 44], XL: [46, 48], XXL: [50, 52], XXXL: [54, 56] } }
  };

  /* ---------------- Helfer ---------------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(n) { return String(n).replace('.', ','); }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  function pageColor() {
    var els = document.querySelectorAll('[data-option-input]:checked');
    for (var i = 0; i < els.length; i++) {
      var v = (els[i].value || '').trim().toLowerCase();
      if (COLORS.indexOf(v) !== -1) return v;
    }
    return null;
  }

  function chartFor(id) {
    if (!PROD[id]) return null;
    var base = (pageId === id && D.product && D.product.chart) || D.charts[PROD[id].handle];
    if (!base || !base.rows || !base.rows.length) return null;
    if (base.groups && st.color) {
      for (var i = 0; i < base.groups.length; i++) {
        var g = base.groups[i];
        var cs = (g.colors || []).map(function (c) { return String(c).toLowerCase(); });
        if (cs.indexOf(st.color) !== -1) return { rows: g.rows, note: g.note || base.note, label: 'Farbe ' + g.label };
      }
    }
    return { rows: base.rows, note: base.note, label: base.groups && base.group_label ? 'Farben ' + base.group_label : '' };
  }
  function convAllowed(id) {
    var c = PROD[id] && PROD[id].conv;
    return c === true || (c === 'clay' && st.color === 'clay');
  }
  function sizesFor(id) {
    var ch = chartFor(id);
    return ch ? ch.rows.map(function (r) { return r.size; }) : SIZES;
  }
  function clamp(i, list) { return Math.max(0, Math.min(list.length - 1, i)); }

  function byChest(rows, chest) {
    for (var i = 0; i < rows.length; i++) if (chest >= rows[i].chest_min && chest < rows[i].chest_max) return { i: i };
    if (chest < rows[0].chest_min) return { i: 0, edge: 'small' };
    return { i: rows.length - 1, edge: 'big' };
  }
  function byHeight(cm, unisex) {
    var t = unisex ? [160, 170, 180, 188, 195, 201] : [160, 168, 176, 183];
    for (var i = 0; i < t.length; i++) if (cm < t[i]) return i;
    return t.length;
  }
  function fromConv(sys, g, n) {
    var t = CONV[sys][g], keys = Object.keys(t);
    for (var i = 0; i < keys.length; i++) if (n >= t[keys[i]][0] && n <= t[keys[i]][1]) return { size: keys[i] };
    if (n < t[keys[0]][0]) return { size: keys[0], edge: 'small' };
    if (n > t[keys[keys.length - 1]][1]) return { size: keys[keys.length - 1], edge: 'big' };
    var best = keys[0], d = 99;
    keys.forEach(function (k) { var dd = Math.min(Math.abs(n - t[k][0]), Math.abs(n - t[k][1])); if (dd < d) { d = dd; best = k; } });
    return { size: best };
  }

  /* ---------------- Salty-Grafik ---------------- */
  var SALTY_SVG =
    '<svg viewBox="0 0 200 200" aria-hidden="true" focusable="false">' +
    '<ellipse cx="100" cy="192" rx="52" ry="5" fill="#003C3A" opacity=".12"/>' +
    '<path d="M66 18 L24 38 C15 42 11 51 14 59 L24 82 C27 89 34 91 40 88 L58 80 Z" fill="#A9502F" stroke="#A9502F" stroke-width="6" stroke-linejoin="round"/>' +
    '<g class="arm"><path d="M134 18 L176 38 C185 42 189 51 186 59 L176 82 C173 89 166 91 160 88 L142 80 Z" fill="#A9502F" stroke="#A9502F" stroke-width="6" stroke-linejoin="round"/></g>' +
    '<path d="M66 18 C80 28 120 28 134 18 C143 27 149 42 149 62 L150 172 C150 181 144 185 136 185 L64 185 C56 185 50 181 50 172 L51 62 C51 42 57 27 66 18 Z" fill="#C2613E" stroke="#C2613E" stroke-width="4" stroke-linejoin="round"/>' +
    '<path d="M66 18 C80 32 120 32 134 18" fill="none" stroke="#A9502F" stroke-width="6" stroke-linecap="round"/>' +
    '<g class="eye"><path d="M82 64 C73 77 73 100 79 113 L82 108 L85 113 C91 100 91 77 82 64 Z" fill="#003C3A" stroke="#003C3A" stroke-width="2" stroke-linejoin="round"/><path d="M82 70 L82 104" stroke="#F3E5D8" stroke-opacity=".55" stroke-width="1.5" stroke-linecap="round"/><ellipse cx="78.5" cy="80" rx="2.6" ry="5" fill="#fff" opacity=".9"/></g>' +
    '<g class="eye"><path d="M118 64 C109 77 109 100 115 113 L118 108 L121 113 C127 100 127 77 118 64 Z" fill="#003C3A" stroke="#003C3A" stroke-width="2" stroke-linejoin="round"/><path d="M118 70 L118 104" stroke="#F3E5D8" stroke-opacity=".55" stroke-width="1.5" stroke-linecap="round"/><ellipse cx="114.5" cy="80" rx="2.6" ry="5" fill="#fff" opacity=".9"/></g>' +
    '<ellipse cx="66" cy="121" rx="9" ry="5.5" fill="#F4A08C"/><ellipse cx="134" cy="121" rx="9" ry="5.5" fill="#F4A08C"/>' +
    '<path d="M86 121 Q100 143 114 121 Q100 125 86 121 Z" fill="#003C3A" stroke="#003C3A" stroke-width="3" stroke-linejoin="round"/>' +
    '<path d="M93 131 Q100 125 107 131 Q100 138 93 131 Z" fill="#EE8A78"/>' +
    '<path d="M78 163 q5.5 -5 11 0 t11 0 t11 0 t11 0" fill="none" stroke="#F3E5D8" stroke-opacity=".75" stroke-width="3" stroke-linecap="round"/>' +
    '</svg>';

  var CSS = [
    ':host{all:initial}',
    '*{box-sizing:border-box}',
    '[hidden]{display:none!important}',
    '.wrap{--ocean:#003C3A;--wave:#3F7768;--sand:#F3E5D8;--white:#FFFDF9;--clay:#C2613E;--ink:#1F2E2D;--muted:#5E6F6B;--line:#E6D9CA;',
    '  font-family:"Raleway","Helvetica Neue",Arial,sans-serif;font-size:15px;line-height:1.5;color:var(--ink)}',
    '.launch{position:fixed;z-index:90;right:calc(16px + env(safe-area-inset-right,0px));bottom:calc(16px + env(safe-area-inset-bottom,0px));',
    '  width:66px;height:66px;border-radius:50%;border:0;padding:8px;background:var(--sand);cursor:pointer;',
    '  box-shadow:0 8px 24px rgba(0,60,58,.22),0 0 0 3px var(--white);transition:transform .2s}',
    '.launch:hover{transform:translateY(-2px) rotate(-4deg)}',
    '.launch svg{width:100%;height:100%;display:block}',
    '.launch:focus-visible,.chip:focus-visible,.send:focus-visible,.x:focus-visible,input:focus-visible,.tease button:focus-visible{outline:3px solid var(--clay);outline-offset:2px}',
    '.tease{position:fixed;z-index:90;right:calc(92px + env(safe-area-inset-right,0px));bottom:calc(30px + env(safe-area-inset-bottom,0px));',
    '  background:var(--white);border:1px solid var(--line);border-radius:16px 16px 4px 16px;padding:10px 34px 10px 14px;max-width:230px;',
    '  font-family:"Montserrat",sans-serif;font-weight:500;font-size:14px;color:var(--ocean);box-shadow:0 8px 24px rgba(0,60,58,.14);cursor:pointer;animation:pop .35s ease-out}',
    '.tease button{position:absolute;top:4px;right:6px;border:0;background:none;font-size:18px;line-height:1;color:var(--muted);cursor:pointer;padding:4px}',
    '.panel{position:fixed;z-index:90;right:calc(16px + env(safe-area-inset-right,0px));bottom:calc(96px + env(safe-area-inset-bottom,0px));',
    '  width:380px;height:min(620px,calc(100vh - 130px));background:var(--white);border-radius:22px;display:flex;flex-direction:column;overflow:hidden;',
    '  box-shadow:0 20px 60px rgba(0,60,58,.25);border:1px solid var(--line);animation:up .28s ease-out}',
    '.head{display:flex;align-items:center;gap:12px;padding:14px 14px 14px 16px;background:var(--ocean);color:var(--white)}',
    '.head .av{width:44px;height:44px;border-radius:50%;background:var(--sand);padding:5px;flex:none}',
    '.head .av svg{width:100%;height:100%;display:block}',
    '.head b{font-family:"Montserrat",sans-serif;font-weight:500;font-size:17px;letter-spacing:.02em;display:block}',
    '.head small{font-size:12.5px;opacity:.8}',
    '.head .x{margin-left:auto;width:36px;height:36px;border-radius:50%;border:0;background:rgba(255,253,249,.12);color:var(--white);font-size:22px;line-height:1;cursor:pointer}',
    '.log{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px;background:linear-gradient(180deg,var(--white),#FBF5EE)}',
    '.log>*{flex-shrink:0}',
    '.msg{max-width:88%;padding:10px 13px;border-radius:16px;white-space:pre-line;overflow-wrap:anywhere}',
    '.bot{background:#fff;border:1px solid var(--line);border-bottom-left-radius:5px;align-self:flex-start}',
    '.me{background:var(--ocean);color:var(--white);border-bottom-right-radius:5px;align-self:flex-end}',
    '.msg strong{font-weight:600;color:var(--ocean)}',
    '.me strong{color:inherit}',
    '.msg a{color:var(--wave)}',
    '.res{align-self:flex-start;display:flex;gap:12px;align-items:center;background:#fff;border:1px solid var(--line);border-radius:16px;padding:12px;max-width:92%}',
    '.res .sz{font-family:"Montserrat",sans-serif;font-weight:500;font-size:34px;line-height:1;color:var(--white);background:var(--clay);border-radius:12px;min-width:70px;padding:12px 8px;text-align:center}',
    '.res .k{font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:var(--muted);margin:0}',
    '.res p{margin:0}',
    '.tbl{align-self:stretch;overflow-x:auto;border:1px solid var(--line);border-radius:12px;background:#fff}',
    '.tbl .cap{font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--muted);padding:8px 12px 0}',
    'table{border-collapse:collapse;width:100%;font-size:13px;font-variant-numeric:tabular-nums}',
    'th,td{padding:6px 10px;text-align:left;border-bottom:1px solid var(--line);white-space:nowrap}',
    'th{font-weight:600;color:var(--muted);font-size:11px;letter-spacing:.06em;text-transform:uppercase}',
    'tr.hit td{background:rgba(194,97,62,.14);font-weight:600}',
    'tr:last-child td{border-bottom:0}',
    '.chips{display:flex;flex-wrap:wrap;gap:6px;padding:10px 14px 4px;background:#FBF5EE}',
    '.chips:empty{display:none}',
    '.chip{font:inherit;font-size:13.5px;border:1.5px solid var(--ocean);color:var(--ocean);background:var(--white);border-radius:999px;padding:6px 12px;cursor:pointer;text-decoration:none}',
    '.chip:hover{background:var(--ocean);color:var(--white)}',
    '.chip.go{background:var(--clay);border-color:var(--clay);color:#fff}',
    '.chip.go:hover{background:#A9502F;border-color:#A9502F}',
    'form{display:flex;gap:8px;padding:10px 14px 14px;background:#FBF5EE;border-top:1px solid var(--line)}',
    'input{flex:1;min-width:0;font:inherit;font-size:16px;border:1px solid var(--line);background:#fff;color:var(--ink);border-radius:999px;padding:9px 14px}',
    '.send{font-family:"Montserrat",sans-serif;font-weight:500;border:0;background:var(--ocean);color:var(--white);border-radius:999px;padding:9px 16px;cursor:pointer}',
    '.typing{display:inline-flex;gap:4px;padding:4px 0}',
    '.typing i{width:6px;height:6px;border-radius:50%;background:var(--muted);animation:dot 1s infinite}',
    '.typing i:nth-child(2){animation-delay:.15s}.typing i:nth-child(3){animation-delay:.3s}',
    '.eye{animation:blink 4.5s infinite;transform-origin:center;transform-box:fill-box}',
    '.arm{transform-box:view-box;transform-origin:138px 26px;animation:wave 6s ease-in-out infinite}',
    '.talk .head .av{animation:hop .5s ease-in-out 2}',
    '@keyframes wave{0%,70%,100%{transform:rotate(0)}76%,88%{transform:rotate(-16deg)}82%,94%{transform:rotate(4deg)}}',
    '@keyframes blink{0%,94%,100%{transform:scaleY(1)}96%{transform:scaleY(.1)}}',
    '@keyframes dot{50%{opacity:.25}}',
    '@keyframes hop{50%{transform:translateY(-5px)}}',
    '@keyframes up{from{opacity:0;transform:translateY(16px)}}',
    '@keyframes pop{from{opacity:0;transform:translateY(8px) scale(.96)}}',
    '@media (max-width:520px){',
    '  .panel{left:0;right:0;bottom:0;width:100%;height:85vh;height:85dvh;border-radius:22px 22px 0 0;border-width:1px 0 0;padding-bottom:env(safe-area-inset-bottom,0px)}',
    '  .tease{max-width:190px}',
    '}',
    '@media (prefers-reduced-motion:reduce){*{animation:none!important;transition:none!important}}',
    '@media print{.wrap{display:none}}'
  ].join('\n');

  /* ---------------- Aufbau ---------------- */
  var host = document.createElement('div');
  host.id = 'salty-chat';
  document.body.appendChild(host);
  var root = host.attachShadow ? host.attachShadow({ mode: 'open' }) : host;
  root.innerHTML =
    '<style>' + CSS + '</style>' +
    '<div class="wrap">' +
      '<div class="tease" hidden><span>Welche Größe passt dir? Frag mich! 👋</span><button type="button" aria-label="Hinweis schließen">×</button></div>' +
      '<button class="launch" type="button" aria-label="Größenberatung mit Salty öffnen" aria-expanded="false">' + SALTY_SVG + '</button>' +
      '<section class="panel" role="dialog" aria-label="Salty, Größenberatung" hidden>' +
        '<div class="head"><div class="av">' + SALTY_SVG + '</div><div><b>Salty</b><small>Dein Größen-Buddy von SALT Ñ SOUL</small></div>' +
        '<button class="x" type="button" aria-label="Chat schließen">×</button></div>' +
        '<div class="log" aria-live="polite"></div>' +
        '<div class="chips"></div>' +
        '<form autocomplete="off"><input type="text" aria-label="Nachricht an Salty" placeholder="z. B. „Ich bin 178 cm“ oder „Herren 50“">' +
        '<button class="send" type="submit">Senden</button></form>' +
      '</section>' +
    '</div>';

  var $ = function (s) { return root.querySelector(s); };
  var wrap = $('.wrap'), launch = $('.launch'), panel = $('.panel'), log = $('.log'), chipsEl = $('.chips'),
      form = $('form'), q = $('input'), tease = $('.tease');
  var st = {}, started = false, lastText = '';

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function scroll() { log.scrollTop = log.scrollHeight; }
  function me(t) { var m = el('div', 'msg me'); m.textContent = t; log.appendChild(m); scroll(); }
  function chips(list) {
    chipsEl.innerHTML = '';
    (list || []).forEach(function (c) {
      var b;
      if (c.href) { b = el('a', 'chip go'); b.href = c.href; b.textContent = c.label; }
      else {
        b = el('button', 'chip' + (c.go ? ' go' : '')); b.type = 'button'; b.textContent = c.label;
        b.onclick = function () { me(c.label); chips([]); c.fn(); };
      }
      chipsEl.appendChild(b);
    });
  }
  var queue = Promise.resolve();
  function say(html, extra) {
    queue = queue.then(function () {
      return new Promise(function (resolve) {
        var t = el('div', 'msg bot', '<span class="typing" aria-label="Salty schreibt"><i></i><i></i><i></i></span>');
        log.appendChild(t); scroll(); wrap.classList.add('talk');
        setTimeout(function () {
          t.innerHTML = html; if (extra) log.appendChild(extra);
          wrap.classList.remove('talk'); scroll(); resolve();
        }, Math.min(350 + html.length * 5, 1000));
      });
    });
    return queue;
  }

  function open() {
    panel.hidden = false; tease.hidden = true; launch.setAttribute('aria-expanded', 'true');
    if (window.matchMedia('(max-width:520px)').matches) launch.hidden = true;
    store('salty-tease', '1');
    if (!started) { started = true; start(); }
    setTimeout(function () { if (!window.matchMedia('(max-width:520px)').matches) q.focus(); }, 50);
  }
  function close() { panel.hidden = true; launch.hidden = false; launch.setAttribute('aria-expanded', 'false'); launch.focus(); }
  launch.addEventListener('click', function () { panel.hidden ? open() : close(); });
  $('.x').addEventListener('click', close);
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
  tease.addEventListener('click', function (e) { if (e.target.tagName === 'BUTTON') { tease.hidden = true; store('salty-tease', '1'); } else open(); });
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-salty-open]');
    if (t) { e.preventDefault(); open(); }
  });
  if (pageId && pageId !== 'beanie' && !store('salty-tease')) setTimeout(function () { if (panel.hidden) tease.hidden = false; }, 3500);

  /* ---------------- Größe empfehlen ---------------- */
  function chartTable(id, hit) {
    var ch = chartFor(id); if (!ch) return null;
    var w = el('div', 'tbl');
    var h = (ch.label ? '<div class="cap">' + esc(ch.label) + '</div>' : '') +
      '<table><thead><tr><th>Größe</th><th>Länge</th><th>½ Brust</th><th>Passt bei Brust</th></tr></thead><tbody>';
    ch.rows.forEach(function (r) {
      h += '<tr class="' + (r.size === hit ? 'hit' : '') + '"><td>' + esc(r.size) + '</td><td>' + num(r.length) + ' cm</td><td>' + num(r.width) +
        ' cm</td><td>' + r.chest_min + '–' + r.chest_max + ' cm</td></tr>';
    });
    w.innerHTML = h + '</tbody></table>';
    return w;
  }
  function convTable(sys, g, hit, id) {
    var t = CONV[sys][g], ch = chartFor(id), w = el('div', 'tbl');
    var h = '<table><thead><tr><th>Größe</th><th>' + esc(sys) + ' ' + (g === 'w' ? 'Damen' : 'Herren') + '</th><th>½ Brust</th></tr></thead><tbody>';
    Object.keys(t).forEach(function (k) {
      var row = ch ? ch.rows.filter(function (r) { return r.size === k; })[0] : null;
      h += '<tr class="' + (k === hit ? 'hit' : '') + '"><td>' + k + '</td><td>' + t[k][0] + '–' + t[k][1] + '</td><td>' + (row ? num(row.width) + ' cm' : '–') + '</td></tr>';
    });
    w.innerHTML = h + '</tbody></table>';
    return w;
  }

  function recommend() {
    var id = st.product, p = PROD[id], ch = chartFor(id), sizes = sizesFor(id), why = '', i, extra = '';
    var classic = st.fit === 'classic';
    if (st.eu && convAllowed(id)) {
      var r = fromConv(st.eu.sys, st.eu.g, st.eu.n);
      i = sizes.indexOf(r.size) - (classic ? 1 : 0);
      why = 'Du trägst sonst ' + esc(st.eu.sys) + ' ' + st.eu.n + ' (' + (st.eu.g === 'w' ? 'Damen' : 'Herren') + '). Das entspricht ' + r.size +
        (classic ? ', für einen klassischeren Sitz eine Nummer kleiner.' : ', damit sitzt es oversized wie gedacht.');
      if (st.eu.g === 'm' && r.size === 'XXL' && !classic) extra = ' Brauchst du mehr Platz an Bauch oder Schultern, nimm XXXL.';
      if (r.edge === 'small') extra = ' Kleiner als ' + sizes[0] + ' gibt es das Teil leider nicht.';
      if (r.edge === 'big') extra = ' Größer als ' + sizes[sizes.length - 1] + ' gibt es das Teil leider nicht.';
    } else if (st.chest && ch) {
      var m = byChest(ch.rows, st.chest);
      i = m.i - (classic ? 1 : 0);
      why = 'Bei ' + st.chest + ' cm Brustumfang' + (classic ? ' und klassischem Sitz' : ' sitzt es locker und oversized, so wie gedacht') + '.';
      if (m.edge === 'small') extra = ' Du liegst unter der kleinsten Größe, das Teil fällt bei dir also extra weit aus.';
      if (m.edge === 'big') extra = ' Du liegst über der größten Größe. Schreib uns gern vorher an info@salt-n-soul.de, dann messen wir nach.';
    } else {
      i = byHeight(st.height, p.unisex);
      if (st.build === 'slim') i -= 1;
      if (st.build === 'broad') i += 1;
      if (classic) i -= 1;
      why = 'Bei ' + st.height + ' cm und ' + ({ slim: 'schmaler', normal: 'normaler', broad: 'kräftiger' })[st.build || 'normal'] + ' Statur' +
        (classic ? ', eher klassisch' : ', oversized wie gedacht') + '.';
      if (ch) extra = ' Mit deinem Brustumfang kann ich noch genauer rechnen.';
    }
    var size = sizes[clamp(i, sizes)];
    st.size = size;
    var label = p.label + (id === 'smile' && st.color ? ' ' + st.color.replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : '');
    var box = el('div', 'res', '<div class="sz">' + esc(size) + '</div><div><p class="k">Salty empfiehlt · ' + esc(label) + '</p><p>' + why + extra + '</p></div>');
    say('Okay, ich hab’s! 🌊', box).then(function () {
      if (st.eu && convAllowed(id)) say('So rechnet sich das um:', convTable(st.eu.sys, st.eu.g, size, id));
      else if (ch) say('Hier die Maße' + (ch.label ? ' (' + esc(ch.label) + ')' : '') + ', deine Größe ist markiert:', chartTable(id, size));
      say((ch && ch.note ? esc(ch.note) + '\n\n' : '') + 'Zwischen zwei Größen? Für den lässigen Beach-Look die größere, für einen ruhigeren Sitz die kleinere.');
      var list = [];
      if (pageId === id && findSizeInput(size)) list.push({ label: 'Größe ' + size + ' auswählen', go: true, fn: function () { pickSize(size); } });
      else if (pageId !== id && D.urls[p.handle]) list.push({ label: 'Zum ' + p.label, href: D.urls[p.handle] });
      list.push({ label: 'Nachbargrößen vergleichen', fn: compare });
      if (!st.chest && ch) list.push({ label: 'Mit Brustumfang genauer', fn: askChest });
      list.push({ label: 'Anderes Teil', fn: askProduct });
      list.push({ label: 'Rückgabe', fn: returns });
      chips(list);
    });
  }
  function findSizeInput(size) {
    var els = document.querySelectorAll('[data-option-input]');
    for (var i = 0; i < els.length; i++) if ((els[i].value || '').trim().toUpperCase() === size) return els[i];
    return null;
  }
  function pickSize(size) {
    var inp = findSizeInput(size);
    if (!inp) return say('Hm, die Größe konnte ich gerade nicht auswählen. Wähl ' + esc(size) + ' bitte direkt bei den Größen aus.');
    inp.click();
    if (!inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    ensureVariant(); setTimeout(ensureVariant, 400);
    say('Erledigt! <strong>' + esc(size) + '</strong> ist ausgewählt. 🤙 Viel Spaß mit deinem neuen Lieblingsteil.');
    chips([{ label: 'Chat schließen', fn: close }, { label: 'Anderes Teil', fn: askProduct }]);
  }
  /* Absicherung: Varianten-ID im Formular muss zur gewählten Größe + Farbe passen */
  function ensureVariant() {
    try {
      var j = document.querySelector('[data-product-json]'), idIn = document.querySelector('[data-variant-id]');
      if (!j || !idIn) return;
      var vs = JSON.parse(j.textContent).variants, chosen = [];
      Array.prototype.forEach.call(document.querySelectorAll('[data-option-input]:checked'), function (i) { chosen[parseInt(i.dataset.index, 10)] = i.value; });
      var v = vs.filter(function (x) { return x.options.every(function (o, k) { return chosen[k] === o; }); })[0];
      if (v && String(idIn.value) !== String(v.id)) idIn.value = v.id;
    } catch (e) {}
  }
  function compare() {
    var sizes = sizesFor(st.product), i = sizes.indexOf(st.size), ch = chartFor(st.product);
    var down = sizes[i - 1], up = sizes[i + 1], t = '';
    function w(s) { var r = ch && ch.rows.filter(function (x) { return x.size === s; })[0]; return r ? ' (½ Brust ' + num(r.width) + ' cm, Länge ' + num(r.length) + ' cm)' : ''; }
    if (down) t += '<strong>' + down + '</strong>' + w(down) + ': näher am Körper, wirkt klassischer.\n';
    t += '<strong>' + st.size + '</strong>' + w(st.size) + ': meine Empfehlung.\n';
    if (up) t += '<strong>' + up + '</strong>' + w(up) + ': richtig weit und lang, der volle Surf-Shop-Look.';
    say(t);
    var list = [];
    if (pageId === st.product) [down, st.size, up].forEach(function (s) { if (s && findSizeInput(s)) list.push({ label: s + ' auswählen', go: s === st.size, fn: function () { pickSize(s); } }); });
    list.push({ label: 'Anderes Teil', fn: askProduct });
    chips(list);
  }

  /* ---------------- Gesprächsschritte ---------------- */
  function start() {
    st = { color: pageColor() };
    if (pageId === 'beanie') return beanie(true);
    if (pageId) {
      st.product = pageId;
      say('Hey, ich bin <strong>Salty</strong> 👕 Ich helfe dir, beim ' + esc(PROD[pageId].label) + ' die richtige Größe zu finden.');
      return chips([
        { label: 'Meine Größe finden', go: true, fn: function () { setProduct(pageId); } },
        { label: 'Wie fällt es aus?', fn: fitInfo },
        { label: 'Maßtabelle zeigen', fn: showTable },
        { label: 'Rückgabe & Umtausch', fn: returns }
      ]);
    }
    say('Hey, ich bin <strong>Salty</strong> 👕 Ich helfe dir, die richtige Größe für unsere Shirts und Hoodies zu finden.\n\nWorum geht’s?');
    chips([
      { label: 'Meine Größe finden', go: true, fn: askProduct },
      { label: 'Wie fallen die Teile aus?', fn: fitInfo },
      { label: 'Wie messe ich richtig?', fn: measure },
      { label: 'Rückgabe & Umtausch', fn: returns }
    ]);
  }
  function askProduct() {
    st = { color: pageColor() };
    say('Für welches Teil suchst du die Größe?');
    chips([
      { label: 'SaltTee Kompass', fn: function () { setProduct('kompass'); } },
      { label: 'SaltTee Smile', fn: function () { st.color = null; setProduct('smile'); } },
      { label: 'SaltTee Basic', fn: function () { setProduct('basic'); } },
      { label: 'Ocean Hug Hoodie', fn: function () { setProduct('hoodie'); } },
      { label: 'Ocean Hug Fluffy (Damen)', fn: function () { setProduct('fluffy'); } },
      { label: 'Beanie', fn: function () { beanie(); } }
    ]);
  }
  function setProduct(id) {
    st.product = id; st.chest = null; st.eu = null;
    if (id === 'smile' && pageId === 'smile' && !st.color) st.color = pageColor();
    if (id === 'smile' && !st.color) return askColor();
    askFit();
  }
  function askColor() {
    say('Welche Farbe? Der Smile in <strong>Clay</strong> hat einen eigenen Schnitt, deshalb frag ich.');
    chips(['Clay', 'Salt', 'Sea Grass', 'Deep Tide', 'Basalt'].map(function (c) {
      return { label: c, fn: function () { st.color = c.toLowerCase(); askFit(); } };
    }));
  }
  function askFit() {
    say('Nice! Unsere Teile sind bewusst weit geschnitten. Wie soll’s bei dir sitzen?');
    chips([
      { label: 'Oversized, so wie gedacht', fn: function () { st.fit = 'over'; askHow(); } },
      { label: 'Eher klassisch', fn: function () { st.fit = 'classic'; askHow(); } }
    ]);
  }
  function askHow() {
    var list = [];
    if (chartFor(st.product)) list.push({ label: 'Ich kenne meinen Brustumfang', go: true, fn: askChest });
    if (convAllowed(st.product)) list.push({ label: 'Ich kenne meine Konfektionsgröße', fn: askGender });
    list.push({ label: 'Nur nach Körpergröße', fn: askHeight });
    say('Wie wollen wir rechnen? Am genauesten geht’s mit deinem Brustumfang.');
    chips(list);
  }
  function askChest() {
    st.step = 'chest';
    say('Wie viel cm misst dein Brustumfang? Maßband locker unter den Achseln um die breiteste Stelle legen. Schreib mir einfach die Zahl, z. B. 98.');
    chips([{ label: 'Wie messe ich richtig?', fn: measure }]);
    q.focus();
  }
  function askHeight() {
    st.step = 'height';
    say('Wie groß bist du? Schreib mir die Zahl in cm oder tipp unten.');
    chips([
      { label: 'unter 165', fn: function () { st.height = 160; askBuild(); } },
      { label: '165–175', fn: function () { st.height = 170; askBuild(); } },
      { label: '176–185', fn: function () { st.height = 181; askBuild(); } },
      { label: 'über 185', fn: function () { st.height = 190; askBuild(); } }
    ]);
  }
  function askBuild() {
    st.step = 'build';
    say('Und deine Statur?');
    chips([
      { label: 'Schmal', fn: function () { st.build = 'slim'; recommend(); } },
      { label: 'Normal', fn: function () { st.build = 'normal'; recommend(); } },
      { label: 'Kräftig / breite Schultern', fn: function () { st.build = 'broad'; recommend(); } }
    ]);
  }
  function askGender() {
    st.eu = {}; st.step = 'gender';
    say('Kaufst du normalerweise Damen- oder Herrengrößen?');
    chips([
      { label: 'Damen', fn: function () { st.eu.g = 'w'; askSystem(); } },
      { label: 'Herren', fn: function () { st.eu.g = 'm'; askSystem(); } }
    ]);
  }
  function askSystem() {
    say('In welchem Größensystem?');
    chips([['DE/AT', 'Deutsch (DE/AT)'], ['FR/ES/PT', 'FR / ES / PT'], ['IT', 'Italienisch (IT)'], ['UK', 'UK']].map(function (x) {
      return { label: x[1], fn: function () { st.eu.sys = x[0]; askEU(); } };
    }));
  }
  function askEU() {
    st.step = 'eu';
    var ex = st.eu.g === 'w' ? { 'DE/AT': 38, 'FR/ES/PT': 40, 'IT': 42, 'UK': 12 } : { 'DE/AT': 50, 'FR/ES/PT': 50, 'IT': 40, 'UK': 40 };
    say('Welche Größe trägst du dort? Schreib mir die Zahl, z. B. ' + ex[st.eu.sys] + '.');
    q.focus();
  }
  function showTable() {
    var id = st.product || pageId;
    if (id === 'smile' && !st.color) { st.color = pageColor(); }
    if (id === 'smile' && !st.color) {
      say('Für welche Farbe? Clay hat einen eigenen Schnitt.');
      return chips(['Clay', 'Salt', 'Sea Grass', 'Deep Tide', 'Basalt'].map(function (c) { return { label: c, fn: function () { st.color = c.toLowerCase(); showTable(); } }; }));
    }
    var t = chartTable(id, st.size);
    if (!t) return say('Für dieses Teil habe ich gerade keine Tabelle. Sag mir einfach deine Körpergröße in cm.');
    say('Die Maße vom ' + esc(PROD[id].label) + ', flach am Kleidungsstück gemessen:', t);
    chips([{ label: 'Meine Größe finden', go: true, fn: function () { setProduct(id); } }, { label: 'Wie messe ich richtig?', fn: measure }]);
  }
  function fitInfo() {
    say('Alle SaltTees und Ocean Hugs sind <strong>unisex und bewusst oversized</strong>: weite Schultern, entspannter Körper. Nimmst du deine normale Größe, bekommst du genau diesen lockeren Look.\n\nMagst du es klassischer, geh eine Nummer kleiner. Der Ocean Hug Fluffy ist ein Damenschnitt mit Loose Fit.');
    chips([{ label: 'Meine Größe finden', go: true, fn: pageId && pageId !== 'beanie' ? function () { setProduct(pageId); } : askProduct }, { label: 'Läuft es ein?', fn: shrink }]);
  }
  function measure() {
    say('So misst du in einer Minute:\n\n<strong>Brustumfang:</strong> Maßband waagerecht unter den Achseln um die breiteste Stelle legen, locker, nicht ziehen.\n\n<strong>Profi-Trick:</strong> Leg dein Lieblingsshirt flach hin und miss von Achsel zu Achsel. Das ist die halbe Brustweite, die kannst du direkt mit unserer Tabelle vergleichen.');
    chips(st.product ? [{ label: 'Brustumfang eingeben', go: true, fn: askChest }] : [{ label: 'Meine Größe finden', go: true, fn: askProduct }]);
  }
  function shrink() {
    say('Kaum. Unsere Shirts sind <strong>vorgewaschen</strong> und sitzen nach der ersten Wäsche wie beim Auspacken.\n\nPflege-Tipp: 30 °C, auf links, an der Luft trocknen. Dann bleiben Form und Print lange schön.');
    chips([{ label: 'Meine Größe finden', go: true, fn: pageId && pageId !== 'beanie' ? function () { setProduct(pageId); } : askProduct }, { label: 'Rückgabe & Umtausch', fn: returns }]);
  }
  function returns() {
    say('Passt doch nicht? Kein Stress. Du hast <strong>30 Tage Rückgaberecht</strong> ab Erhalt. Die Rücksendekosten trägst du, dein gesetzliches Widerrufsrecht bleibt natürlich bestehen.\n\nFragen? Schreib uns an <a href="mailto:info@salt-n-soul.de">info@salt-n-soul.de</a>');
    chips([{ label: 'Meine Größe finden', go: true, fn: pageId && pageId !== 'beanie' ? function () { setProduct(pageId); } : askProduct }]);
  }
  function beanie(onPage) {
    say((onPage ? 'Hey, ich bin <strong>Salty</strong> 👕 ' : '') + 'Die <strong>Dawn Patrol Beanie</strong> ist One Size und unisex. Der Merino-Rippstrick dehnt sich mit, und mit dem breiten Umschlag stellst du ein, wie tief sie sitzt. Passt einfach.');
    chips([{ label: 'Größe für Shirt oder Hoodie', fn: askProduct }]);
  }

  /* ---------------- Freitext ---------------- */
  function detectProduct(t) {
    if (/kompass/.test(t)) return 'kompass';
    if (/fluffy/.test(t)) return 'fluffy';
    if (/hood|hug|pulli/.test(t)) return 'hoodie';
    if (/basic/.test(t)) return 'basic';
    if (/smile/.test(t)) return 'smile';
    return null;
  }
  function handle(text) {
    var t = text.toLowerCase(); lastText = t;
    var mm = t.replace(',', '.').match(/\d+(\.\d+)?/), n = mm ? parseFloat(mm[0]) : NaN;

    if (st.step === 'chest' && n) {
      if (n < 60 || n > 180) return say('Hm, das klingt nicht nach einem Brustumfang. Schreib mir die Zahl in cm, z. B. 98.');
      st.chest = Math.round(n); st.step = null; return recommend();
    }
    if (st.step === 'eu') {
      if (!n) return say('Schreib mir nur die Zahl deiner Konfektionsgröße, z. B. 40.');
      st.eu.n = Math.round(n); st.step = null; return recommend();
    }
    var kf = t.match(/(größe|groesse|gr\.?|trage|damen|herren|konfektion\w*)\D{0,12}(\d{1,2})\b/);
    if (kf && !/cm/.test(t)) {
      var k = parseInt(kf[2], 10);
      st.product = detectProduct(t) || st.product || pageId;
      if (st.product === 'smile' && !st.color) st.color = /clay/.test(t) ? 'clay' : pageColor();
      if (!st.product || st.product === 'beanie') {
        say('Größe ' + k + ', notiert. Für welches Teil soll ich das umrechnen?');
        st.pendingEU = k;
        return chips([
          { label: 'Ocean Hug Hoodie', fn: function () { st.product = 'hoodie'; handle(lastText); } },
          { label: 'SaltTee Kompass', fn: function () { st.product = 'kompass'; handle(lastText); } }
        ]);
      }
      if (!convAllowed(st.product)) return say('Konfektionsgrößen kann ich für den ' + esc(PROD[st.product].label) + (st.product === 'smile' ? ' in dieser Farbe' : '') + ' leider nicht umrechnen. Sag mir deinen Brustumfang in cm, dann wird’s ganz genau.'), chips([{ label: 'Brustumfang eingeben', go: true, fn: askChest }]);
      st.fit = st.fit || (/klassisch|eng/.test(t) ? 'classic' : 'over');
      st.eu = { n: k, sys: /uk|engl|brit/.test(t) ? 'UK' : /ital/.test(t) ? 'IT' : /franz|span|portug/.test(t) ? 'FR/ES/PT' : 'DE/AT' };
      if (/damen|frau/.test(t)) st.eu.g = 'w'; else if (/herren|mann|männ/.test(t)) st.eu.g = 'm';
      if (st.eu.g) return recommend();
      say('Größe ' + k + ', notiert. Damen- oder Herrengröße?');
      return chips([{ label: 'Damen', fn: function () { st.eu.g = 'w'; recommend(); } }, { label: 'Herren', fn: function () { st.eu.g = 'm'; recommend(); } }]);
    }
    if (/brust/.test(t) && n >= 60 && n <= 180) {
      st.product = detectProduct(t) || st.product || pageId;
      st.chest = Math.round(n);
      if (!st.product || st.product === 'beanie') { say(st.chest + ' cm Brustumfang, notiert. Für welches Teil?'); return askProductKeep(); }
      if (st.product === 'smile' && !st.color) { st.color = pageColor(); if (!st.color) return askColor(); }
      st.fit = st.fit || 'over'; return recommend();
    }
    if (n >= 140 && n <= 215) {
      st.height = n; st.chest = null; st.eu = null;
      st.product = detectProduct(t) || st.product || (pageId !== 'beanie' ? pageId : null);
      st.fit = st.fit || (/klassisch|eng/.test(t) ? 'classic' : 'over');
      if (!st.product) { say(n + ' cm, notiert. Für welches Teil?'); return askProductKeep(); }
      if (st.product === 'smile' && !st.color) { st.color = pageColor(); }
      return askBuild();
    }
    if (st.step === 'height' && n) return say('Schreib mir deine Körpergröße in cm, z. B. 178.');
    if (/einlauf|läuft.*ein|schrumpf|wasch/.test(t)) return shrink();
    if (/rück|umtausch|zurück|retour|widerruf/.test(t)) return returns();
    if (/mess|maßband/.test(t)) return measure();
    if (/beanie|mütze/.test(t)) return beanie();
    if (/tabelle|maße|maß/.test(t)) { st.product = detectProduct(t) || st.product || pageId; if (st.product && st.product !== 'beanie') return showTable(); return askProduct(); }
    if (/groß aus|klein aus|fällt|oversize|weit|schnitt|sitz/.test(t)) return fitInfo();
    if (/kontakt|mail|mensch|hilfe|team/.test(t)) return say('Unser Team erreichst du unter <a href="mailto:info@salt-n-soul.de">info@salt-n-soul.de</a>. Wir antworten persönlich.');
    var dp = detectProduct(t);
    if (dp) { st.color = /clay/.test(t) ? 'clay' : (pageId === 'smile' ? pageColor() : null); return setProduct(dp); }
    if (/shirt|tee/.test(t)) return askProduct();
    if (/hallo|hey|\bhi\b|moin|servus|grüß/.test(t)) return say('Hey! 🤙 Sag mir, welches Teil du dir anschaust und wie groß du bist.');
    say('Da bin ich überfragt, ich kenne mich vor allem mit Größen aus. Frag mich z. B. „Welche Größe beim Hoodie bei 182 cm?“ oder „Läuft das Shirt ein?“\n\nFür alles andere: <a href="mailto:info@salt-n-soul.de">info@salt-n-soul.de</a>');
    chips([{ label: 'Meine Größe finden', go: true, fn: pageId && pageId !== 'beanie' ? function () { setProduct(pageId); } : askProduct }]);
  }
  function askProductKeep() {
    var go = function (id) { return function () { st.product = id; st.fit = st.fit || 'over'; if (id === 'smile' && !st.color) return askColor2(); st.chest ? recommend() : askBuild(); }; };
    chips([
      { label: 'SaltTee Kompass', fn: go('kompass') }, { label: 'SaltTee Smile', fn: go('smile') }, { label: 'SaltTee Basic', fn: go('basic') },
      { label: 'Ocean Hug Hoodie', fn: go('hoodie') }, { label: 'Ocean Hug Fluffy (Damen)', fn: go('fluffy') }
    ]);
  }
  function askColor2() {
    say('Welche Farbe? Der Smile in <strong>Clay</strong> hat einen eigenen Schnitt.');
    chips(['Clay', 'Salt', 'Sea Grass', 'Deep Tide', 'Basalt'].map(function (c) {
      return { label: c, fn: function () { st.color = c.toLowerCase(); st.chest ? recommend() : askBuild(); } };
    }));
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = q.value.trim(); if (!v) return;
    me(v); q.value = ''; chips([]); handle(v);
  });

  /* Test-/Debug-Haken */
  window.Salty = { open: open, close: close };
})();
